module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('basic-modal', _vm._b({
    ref: "basicModal",
    attrs: {
      "cssAfectsWidth": false
    }
  }, 'basic-modal', _vm.modal, false), [_c('div', {
    staticClass: "dialog-modal"
  }, [(_vm.hasHeader) ? [_c('div', {
    staticClass: "dialog-modal__header"
  }, [_vm._v("\n        " + _vm._s(_vm.header) + "\n      ")])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-modal__content"
  }, [(_vm.message) ? [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")] : _vm._t("content")], 2), _vm._v(" "), (_vm.hasFooter) ? [_c('div', {
    staticClass: "dialog-modal__footer"
  }, [_c('hr'), _vm._v(" "), (!_vm.hasFooterSlot) ? [_c('div', {
    staticClass: "dialog-modal__footer__buttons"
  }, [_c('action-button', {
    attrs: {
      "color": "success",
      "label": "yesLabel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickYes.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "label": "noLabel",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickNo.apply(null, arguments)
      }
    }
  })], 1)] : _vm._t("footer")], 2)] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-323d4615","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/modal/DialogModal.vue
// module id = 2038
// module chunks = 0